export const refreshInterval = 15000;
